<template>
  <section id="app">
    <login-modal></login-modal>
    <side-bar></side-bar>

    <div class="header-holder">
      <main-menu-trigger id="menu-trigger"></main-menu-trigger>
      <logo v-if="printStoreMobileHeader"></logo>
    </div>
    <div id="main-view">
      <router-view></router-view>
    </div>

    <!--     <v-dialog class="dialog-container" /> -->
    <span id="version-dialog"></span>

    <dialog ref="cookieDialog" class="cookie-dialog">
      <cookie-dialog @close="hideCookieDialog()"></cookie-dialog>
    </dialog>
  </section>
</template>

<script>
import LoginModal from '@/dialogs/LoginModal.vue'
import OldBrowser from '@/dialogs/OldBrowser.vue'
import SideBar from '@/components/SideBar.vue'
import MainMenuTrigger from '@/components/MainMenuTrigger.vue'

import { EventBus, Events } from '@/eventbus/EventBus.js'

import Logo from '@/components/Logo.vue'
import SessionCheckMixin from '@/mixins/SessionCheckMixin'
import CookieDialog from '@/dialogs/CookieDialog.vue'
import { hasConsentCookie } from '@/api/Cookies'

import { useFileListStore } from '@/stores/FileList.store'

import { storeToRefs } from 'pinia'

export default {
  data() {
    return {
      resizeObserver: undefined,
      displayCookieButton: false
    }
  },
  components: {
    CookieDialog,
    LoginModal,
    SideBar,
    MainMenuTrigger,
    Logo
  },
  mixins: [SessionCheckMixin],
  async created() {
    EventBus.on(Events.REQUEST_LOGIN, (payload) => {
      this.$modal.show('login')
    })

    // verifyAppVersion()

    // eventbus.on(Events.NEW_VERSION_AVAILABLE, () => {
    //   const VersionDialog = Vue.extend(NewVersion)
    //   new VersionDialog().$mount('#version-dialog')
    // })

    EventBus.on(Events.ENABLE_GTM, (enabled) => {
      this.$gtm.enable(enabled)
    })

    EventBus.on(Events.SHOW_COOKIE_DIALOG, () => {
      this.displayCookieDialog()
    })

    window.onfocus = () => {
      this.sessionCheck()
    }
  },
  mounted() {
    const sAgent = window.navigator.userAgent
    const Idx = sAgent.indexOf('MSIE')

    // If IE, return version number.
    if (Idx > 0 || !!navigator.userAgent.match(/Trident\/7\./)) {
      this.$modal.show(OldBrowser, null, {
        height: 'auto',
        width: 400
      })
    }

    this.rootStore.setWindowInnerHeight(window.innerHeight)

    new ResizeObserver(this.onResize).observe(
      document.body
    )
    this.onResize()

    if (!hasConsentCookie()) {
      this.displayCookieDialog()
    }
  },
  methods: {
    displayCookieDialog() {
      this.$refs.cookieDialog.show()
    },
    hideCookieDialog() {
      this.$refs.cookieDialog.close()
    },
    onResize() {
      this.rootStore.setWindowInnerHeight(window.innerHeight)

      const isMobile = window.innerHeight < 400 || window.innerWidth < 620
      this.rootStore.setMobile(isMobile)
    }
  },
  computed: {
    fileList() {
      const { fileList } = storeToRefs(useFileListStore())
      return fileList.value
    },
    showRijnjaContent() {
      return !!this.rootStore.theme.showRijnjaContent;
    },
    printStoreMobileHeader() {
      return !(this.rootStore.currentSection === 'printstore' &&
        this.rootStore.isMobile);
    }
  }
}
</script>

<style lang="scss">
/* Global CSS variables for theming */
:root {
  --main-color: #012169;
  --sub-color: #012169;
  --icon-color: #012169;
  --text-color: #4f4f4f;
  --hover-color: #f0f0f0;
  --error-color: #fd514d;
  --action-color: #ff9800;
  //--mobile-width: 734px;

  --default-shadow: rgba(96, 96, 96, 0.2) 0 4px 13px;
  //  --default-shadow-hover: rgba(96, 96, 96, 0.2) 0px 10px 16px 3px;
  --default-shadow-hover: rgba(100, 100, 100, 0.35) 0px 4px 11px 0px;
}

.sub-color {
  color: var(--sub-color);
}

.sub-color-background {
  color: var(--sub-color);
}

#app {
  //overflow-x: hidden;
}

.dialog-container.vm--container {
  z-index: 2000;
}

.badge-holder {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

#main-view {
  min-height: 100vh;
}

.header-holder {
  //position: fixed;
  top: 0;
  z-index: 100;
  width: 100vw;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}

.terms-link {
  text-decoration: none;
  color: #002169;
  border-bottom: 1px dotted;
}

.clickable {
  cursor: pointer;
}

.cookie-dialog {
  position: fixed;
  bottom: 10px;
  left: calc(100vw - 320px);
  border-radius: 12px;
  width: 300px;
  z-index: 2;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}

.specs-block {
  box-shadow: var(--default-shadow);
  border-radius: 20px;
  padding: 20px;
}
</style>
